export const config = {
  apiKey: 'AIzaSyBdK2WUl8SSZCofCF5peKATO-qN469jKIc',
  authDomain: 'meetups-e7599.firebaseapp.com',
  databaseURL: 'https://meetups-e7599.firebaseio.com',
  projectId: 'meetups-e7599',
  storageBucket: 'meetups-e7599.appspot.com',
  messagingSenderId: '351354889583'
}



// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js